import styled from "styled-components";
import totalRateImg from './../../assets/total_rate.png';
import scoreImg from './../../assets/start_in_round.png';
import {useAnimatedCounter} from "../../hooks/useAnimatedCounter";
import {useAppContext} from "../../provider/AppProvider";
import {memo} from "react";


const Container = styled.div`
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 10px;
    
    @media (min-width: 768px) {
        height: 120px;
    }

    @media (min-width: 1024px) {
        height: 150px;
    }
`;

const Template = styled.div`
    background: rgba(85, 136, 255, 0.5);
    border-radius: 16px;
    min-width: 100px;
    color: white;
    text-align: end;
    padding: 4px 10px;
    gap: 6px;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    @media (min-width: 768px) {
        min-width: 150px;
        font-size: 20px;
    }

    @media (min-width: 1024px) {
        min-width: 300px;
        font-size: 36px;
    }
`;

const Image = styled.img`
    height: 30px;
    width: 30px;

    @media (min-width: 768px) {
        height: 45px;
        width: 45px;
    }

    @media (min-width: 1024px) {
        height: 80px;
        width: 80px;
    }

    -webkit-user-select: none; /* Safari */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;

    pointer-events: none; /* Prevent any interactions */
    user-drag: none; /* Disable image dragging */
    -webkit-user-drag: none; /* Disable image dragging for Safari */
`;

interface Props {
    score: number;
    totalScore: number;
}

export const Score = memo(({score = 0, totalScore = 0}: Props) => {
    const {onSwitchLeaderBord} = useAppContext();
    const animatedScore = useAnimatedCounter(score)

    return (
        <Container>
            <Template>
                <Image src={scoreImg} />
                {animatedScore}
            </Template>
            <Template style={{zIndex: 12}} onClick={onSwitchLeaderBord}>
                <Image src={totalRateImg} />
                {totalScore}
            </Template>
        </Container>
    )
})
